import React from 'react'
import { Outlet } from 'react-router-dom';
import FrontHeader from "../shared/FrontHeader";
import FrontFooter from "../shared/FrontFooter";

const AuthLayout = () => {
  console.log(FrontHeader)
  return (
    <>
      <FrontHeader />
      <Outlet />
      <FrontFooter/>
    </>
  )
}

export default AuthLayout;